// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatProjectsPageSkeleton-modulecard__Uv5bf";
var _2 = "GretaAIChatProjectsPageSkeleton-modulegrid__Z3EK3 GretaAIChatProjectsPageGrid-modulegrid__jMFv7";
var _3 = "GretaAIChatProjectsPageSkeleton-modulemeta__XVJyo Skeleton-moduleSkeleton__Mlrfv";
var _4 = "GretaAIChatProjectsPageSkeleton-modulescope__qngU6 Skeleton-moduleSkeleton__Mlrfv";
var _5 = "GretaAIChatProjectsPageSkeleton-moduletitle__zxBzm Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "card", _2 as "grid", _3 as "meta", _4 as "scope", _5 as "title" }
